import React, { PureComponent } from "react";
import PropTypes from "prop-types";
import styled from "styled-components";
import { connect } from "react-redux";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faMoon } from "@fortawesome/free-solid-svg-icons";
import { actions as uiActions } from "../actions/userInterface";
import { IconButton } from "../styled-components";
import Settings from "../settings";

class DarkLightModeButton extends PureComponent {
  toggleTheme = () => {
    if (this.props.themeName === "standard") {
      this.props.changeTheme("dark");
    } else {
      this.props.changeTheme("standard");
    }
  };
  render() {
    const { themeName } = this.props;
    if (!Settings.enableThemes) {
      return "";
    }
    return (
      <IconButton
        active={themeName === "dark"}
        onClick={() => this.toggleTheme()}
      >
        <FontAwesomeIcon fixedWidth size="xs" icon={faMoon} />
      </IconButton>
    );
  }
}

DarkLightModeButton.propTypes = {
  theme: PropTypes.object.isRequired,
  themeName: PropTypes.string.isRequired,
  changeTheme: PropTypes.func.isRequired
};

const mapStateToProps = state => ({
  theme: state.userInterface.theme,
  themeName: state.userInterface.themeName
});

const mapActionHandlers = {
  changeTheme: uiActions.changeTheme
};

export default connect(mapStateToProps, mapActionHandlers)(DarkLightModeButton);



// WEBPACK FOOTER //
// ./app/components/DarkLightModeButton.js